module.exports = __webpack_public_path__ + "img/875-2e0532.png";